type PhoneContact = {
  phoneNumber?: string
  phoneNumberExtension?: string
  country?: 'USA' | 'CAN' | 'MEX' | 'CHN' | 'DEU' | 'IND' | 'IRL' | 'JPN' | 'KOR' | 'TWN' | 'VNM'
}

export function formatPhoneNumber(contact?: Partial<PhoneContact>): string {
  if (!contact?.phoneNumber) {
    return 'No phone number information available.'
  }

  const COUNTRY_PHONE_PREFIX: Record<NonNullable<Partial<PhoneContact>['country']>, string> = {
    USA: '+1',
    CAN: '+1',
    MEX: '+52',
    CHN: '+86',
    DEU: '+49',
    IND: '+91',
    IRL: '+353',
    JPN: '+81',
    KOR: '+82',
    TWN: '+886',
    VNM: '+84',
  }

  const prefix = contact.country ? COUNTRY_PHONE_PREFIX[contact.country] : ''
  let formattedNumber = prefix ? `${prefix} ${contact.phoneNumber}` : contact.phoneNumber

  if (contact.phoneNumberExtension) {
    formattedNumber += ` Ext. ${contact.phoneNumberExtension}`
  }

  return formattedNumber
}
